<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>语音验证码管理</li>
                <li><a href="voicecodelog">语音验证码日志</a></li>
            </ul>
        </div>
        
        <div class="rightinfo">
            <ul class="seachform mt20">
                <li><label>手机号</label><input name="" v-model="mobile" type="text" class="scinput" /></li>
                <li>
                    <label>月份</label>
                    <el-date-picker v-model="month" name="month" id="month" type="month"
                        format="MM" value-format="MM" placeholder="选择日期" style="width: 120px;"/></li>
                <li>
                <input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
            </ul>

            <div class="pagin" style="margin-bottom: 15px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>

            <table class="tablelist">
                <thead>
                    <tr>
                    <th>手机号</th>
                    <th>短信内容</th>
                    <th>发送时间</th>
                    <th>结束时间</th>
                    <th>接听时间（分钟）</th>
                    <th>是否接听</th>
                    </tr>
                </thead>
                <tbody>                
                    <tr v-for="item in cvoicelogList">
                        <td style="width:10%">
                            {{item.destcallnum}}
                        </td>
                        <td style="width:35%">
                            {{item.voicecontent}}
                        </td>
                        <td style="width:15%">
                            <template v-if="item.starttime == undefined">

                            </template>
                            <template v-else>
                                {{item.starttime.substring(0, 19)}}
                            </template>
                        </td>
                        <td style="width:15%">
                            <template v-if="item.endtime == undefined">

                            </template>
                            <template v-else>
                                {{item.endtime.substring(0, 19)}}
                            </template>
                        </td>
                        <td>
                            {{item.costtime}}
                        </td>
                        <td>
                            <template v-if="item.status == 1">
                                成功接听
                            </template>
                            <template v-else>
                                对方没有应答
                            </template>
                        </td>
                    </tr>
                    <tr v-if="cvoicelogList.length == 0">
                        <td colspan="6">
                            没有找到相关记录
                        </td>
                    </tr>               
                </tbody>
            </table>

            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import { openPostWindow,openPostWindow2 } from '../../assets/js/winopen.js';
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            month: '',
            pageIndex:0,
            pageSize: 50,
            totalCount:0,
            cvoicelogList: [],
        }
    },
    mounted(){
        this.nowmonth();
        this.pageChange(1);
    },
    methods:{
        nowmonth() {
            if(0 < (new Date().getMonth() + 1) && (new Date().getMonth() + 1) < 10)
            {
                this.month = "0" + (String)(new Date().getMonth() + 1);
            }
            else
            {
                this.month = (String)(new Date().getMonth() + 1);
            }
        },
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            if(typeof(this.month) == 'object' || this.month == null)
            {
                this.$alert("请输入查询月份");
                return false;
            }
            let that = this;
            let data = {'pageIndex' : pageIndex, 'pageSize' : this.pageSize, 'descNum' : this.mobile, 'month': this.month, 'startTime': '', 'startTime_end': ''};
            // alert(JSON.stringify(data))
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/voice/voicevalicationcode.json",
                data: data,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.cvoicelogList = res.data.cvoicelogList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    // console.log(that.cvoicelogList)
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/voicecode/voicecodelog.vue